import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FacebookTwitterJson} from '../model/facebookTwitterJson';
import {ProjectService} from '../project/project.service';
import {Project} from '../model/project';
import {Terminal} from '../model/terminal';
import {TerminalUtil} from '../util/terminalUtil';
import {MaterialChipsInputComponent} from '../project/tags/materialChipsInput.component';

@Component(
  {
    selector:'socialMediaContentDefinition',
    template:`
      <div class="modal" tabindex="-1" role="dialog" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel"><span><img  *ngIf="this.facebookDef" class="titleBar" src="../../../assets/images/facebook.png"><img  *ngIf="!this.facebookDef" class="titleBar" src="../../../assets/images/twitter.png"></span>{{title}}</h5>
              <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="hideDialog()" aria-label="Close">
                <span class="closeX" aria-hidden="true"><i class="fas fa-times"></i></span>
              </button>
            </div>
            <div class="modal-body">

              <div> Content Definition Language</div>
              <div class="mat-app-background basic-container" style="border-style: dashed;border-color: #0b51c5;border-width: medium;padding-left: 10%;padding-right: 10%;">
                <material-chips-input (reload)="setSelectedLanguage($event)">loading</material-chips-input>
              </div>

              <br/>

              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-default">Question Number To Share</span>
                </div>
                <input type="number" class="questionNumber" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" min="1" [value]="facebookTwitterConf.questionNo" [(ngModel)]="facebookTwitterConf.questionNo">
              </div>

              <div *ngIf="!facebookDef" class="input-group mb-3">
                <label for="useAsUrl">Use As Url</label>
                <input id="useAsUrl" type="checkbox" style="height:23px; width:23px;" class="useAsUrl" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" [checked]="facebookTwitterConf.useImageAsUrl" [(ngModel)]="facebookTwitterConf.useImageAsUrl">
              </div>

              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width:203px;" id="inputGroup-sizing-default">Title</span>
                </div>
                <input type="text" class="title" aria-label="Title Input" aria-describedby="inputGroup-sizing-default" [value]="facebookTwitterConf.getTitle(lang)" [(ngModel)]="facebookTwitterConf.currentTitle" (ngModelChange)="updateTitle($event)">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"  style="width:203px;" id="inputGroup-sizing-default">Description</span>
                </div>
                <input type="text" class="description" aria-label="Desc Input" aria-describedby="inputGroup-sizing-default" [value]="facebookTwitterConf.getDesc(lang)" [(ngModel)]="facebookTwitterConf.currentDesc" (ngModelChange)="updateDescription($event)">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width:203px;" id="inputGroup-sizing-default">SocialMessage</span>
                </div>
                <input type="text" class="socialMessage" aria-label="Message Input" aria-describedby="inputGroup-sizing-default" [value]="facebookTwitterConf.getMessage(lang)" [(ngModel)]="facebookTwitterConf.currentMsg" (ngModelChange)="updateSocialMessage($event)">
              </div>
            </div>
            <!-- footer-->
            <div class="modal-footer ">
              <button type="submit" class="btn btn-primary btn-lg" (click)="saveConfiguration()"><span style="margin-right:10px;"><i
                class="fas fa-save"></i></span>{{'save'|translate}}</button>
            </div>
          </div>
        </div>
      </div>
    `,
    styles:[`
    .questionNumber{-moz-appearance: textfield;}
      #useAsUrl{margin-left: 15px;}

    .modal-header{
      background-color:dodgerblue;
      color:antiquewhite;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
    }
    .modal-content{
      border-top-right-radius: 18px;
      border-top-left-radius: 18px;
    }
    .closeX{color:azure;size:25px;}
    .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
    .btn-danger:hover{background-color: #FF2400;}
        .titleBar{margin-right: 5px;height:32px;}

    `]
  }
)

export class  SocialMediaContentDefinitionComponent implements OnChanges,OnInit {

  @Input() facebookDef:boolean;

  @Input() project:Project;

  @Input() terminal:Terminal;

  @Output() confPosted:EventEmitter<string>  = new EventEmitter();

  @ViewChild(MaterialChipsInputComponent) materialTagChips:MaterialChipsInputComponent;

  private title:string;

  private facebookTwitterConf:FacebookTwitterJson;

  private lang:string;

  constructor(private projectService:ProjectService) {
  }
  private hide = true;

  ngOnInit(): void {
    this.initialize();
    this.getSocialMediaConfig();
  }


  public hideDialog() {
    this.hide = !this.hide;
  }

  setSelectedLanguage(lang: string) {
    this.lang = lang;
  }



  updateTitle(title: string) {
    this.facebookTwitterConf.title.set(this.lang,title);
    this.facebookTwitterConf.currentTitle = title;
  }

  updateDescription(desc: string) {
    this.facebookTwitterConf.description.set(this.lang,desc);
    this.facebookTwitterConf.currentDesc = desc;
  }

  updateSocialMessage(msg: string) {
    this.facebookTwitterConf.socialMessage.set(this.lang,msg);
    this.facebookTwitterConf.currentMsg = msg;
  }


  saveConfiguration() {
    this.projectService.facebookTwitterConfig(this.project.id,this.terminal.associatedQuestionnaireId,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type),this.facebookTwitterConf,this.facebookDef).subscribe((next:string)=> {
      this.confPosted.emit('OK');
    });
  }


  ngOnChanges(changes: SimpleChanges): void {

    this.initialize();
    this.getSocialMediaConfig();

  }

  private initialize() {
    if(this.facebookDef) {
      this.title = 'Facebook Content Definition';
      this.facebookTwitterConf = new FacebookTwitterJson('');
    } else {
      this.title = 'Twitter Content Definition';
      this.facebookTwitterConf = new FacebookTwitterJson('');
    }
  }

  private getSocialMediaConfig() {
    this.projectService.getFacebookTwitterConfig(this.project.id,this.terminal.associatedQuestionnaireId,this.terminal.id,TerminalUtil.getTerminalTypeId(this.terminal.type),this.facebookDef).subscribe((json:string)=> {
      if(json.length>0) {
        this.facebookTwitterConf = new FacebookTwitterJson(JSON.parse(json));
      }
      this.lang = this.facebookTwitterConf.getLanguages()[0];
      this.materialTagChips.setLanguageArray(this.facebookTwitterConf.getLanguages());
      this.materialTagChips.setSelectedLanguage(this.lang);
      this.materialTagChips.setId(this.lang);
    });
  }
}
